module.exports = __webpack_public_path__ + "img/EmailFail.34368703.svg";